export default __webpack_public_path__ + "static/media/pixbox.d3970e73.png";